<template>
  <div class="animated revealUp">
    <div class="d-flex justify-content-between">
      <div>
        <div class="section-title">SMS Campaigns</div>
        <div class="section-subTitle my-2">Manage All you marketing sms campaigns</div>
      </div>
      <div>
        <!-- <b-button variant="default" to="profile" class="btn-blue">{{ $t('Profile') }}</b-button> -->
        <!-- v-if="cinema_manager_add_edit_disabled != 3" -->
        <b-button
          variant="default"
          :to="{name: 'Add sms Campaign',params: { token: Math.floor(10000000 + Math.random() * 90000000)}}"
          class="btn-blue"
        >{{ $t('add') }}</b-button>
      </div>
    </div>

    <!-- <div class="d-flex justify-content-between align-items-center my-3">
      <div class="d-flex"></div>
      <div class="d-flex align-items-center">
        <div class="mx-2">
          <b-dropdown id="listview" variant="outline-blue">
            <template v-slot:button-content>
              Viewing&nbsp;
              <strong>{{selectedvalue}}</strong>
              &nbsp;Of&nbsp;
              <strong>{{ rows }}</strong>
            </template>
            <b-dropdown-item
              v-for="(list, listIndex) in viewingnumbers"
              :key="listIndex"
              @click="onDropDownChangeValue(list.name)"
            >{{list.name}}</b-dropdown-item>
          </b-dropdown>
        </div>

        <button
          class="btnj btn-gridView mr-3"
          v-if="GridViewFlag"
          :class="gridView ? 'active':''"
          v-on:click="viewType('gridView')"
        ></button>
        <button
          class="btnj btn-listView"
          v-if="GridViewFlag"
          :class="listView ? 'active':''"
          v-on:click="viewType('listView')"
        ></button>
      </div>
    </div>-->

    <!-- LIST VIEW DESIGNATION -->
    <!-- <div class="desg-list-container">
      <div class="desg-list-header">
        <div>SMS campaigns</div>
        <div>Completion Status</div>
        <div class="pr-5">{{ $tc('status', 2) }}</div>
      </div>
      <ul class="desg-list">
        <li v-for="(campaign, campaignLoopKey) in campaigns_array" :key="campaignLoopKey">
          <div>{{campaign.campaign_name}}</div>
          <div>{{campaign.sms_campaign_status}}</div>
          <div class="d-flex align-items-center">
            <label class="ios-switch">
              <input
                v-model="campaign.campaign_is_active"
                value="Y"
                disabled
                type="checkbox"
                class="ios-checkbox"
              />
              <span class="switch-slider"></span>
            </label>
            <b-dropdown right variant="edit" class="ml-4">
              <b-dropdown-item
                :to="{ name: 'Edit sms Campaign', params: { sc_id: campaign.sc_id } }"
              >
                <span class="edit-pen mr-1"></span>
                {{ $t('edit') }}
              </b-dropdown-item>
              <b-dropdown-item
                :to="{ name: 'View sms Campaign', params: { sc_id: campaign.sc_id } }"
              >
                <span class="icon-eye mr-1"></span>
                {{ $t('view') }}
              </b-dropdown-item>
            </b-dropdown>
          </div>
        </li>
    </ul>-->
    <!-- <table>
        <tbody>
          <tr>
            <td colspan="2">
              <div class="h6 my-3 text-center">{{ $t('NoRecords') }}</div>
            </td>
          </tr>
        </tbody>
    </table>-->
    <!-- </div>
    <br />-->

    <div class="">
      <table class="list-view-table">
        <thead>
          <tr class="text-center">
            <th class="text-left">SMS Campaigns</th>
            <th>Completion Status</th>
            <th class="text-right pr-5">Status</th>
          </tr>
        </thead>
        <tbody>
          <tr
            class="text-center"
            v-for="(campaign, campaignLoopKey) in campaigns_array"
            :key="campaignLoopKey"
          >
            <td class="text-left">{{campaign.campaign_name}}</td>
            <td>{{campaign.sms_campaign_status}}</td>
            <td class="text-right">
              <div>
                <label class="ios-switch">
                  <input
                    v-model="campaign.campaign_is_active"
                    value="Y"
                    disabled
                    type="checkbox"
                    class="ios-checkbox"
                  />
                  <span class="switch-slider"></span>
                </label>
                <b-dropdown right variant="edit" class="ml-4">
                  <b-dropdown-item
                    :to="{ name: 'Edit sms Campaign', params: { sc_id: campaign.sc_id } }"
                  >
                    <span class="edit-pen mr-1"></span>
                    {{ $t('edit') }}
                  </b-dropdown-item>
                  <b-dropdown-item
                    :to="{ name: 'View sms Campaign', params: { sc_id: campaign.sc_id } }"
                  >
                    <span class="icon-eye mr-1"></span>
                    {{ $t('view') }}
                  </b-dropdown-item>
                </b-dropdown>
              </div>
            </td>
          </tr>
        </tbody>
        <tbody v-if="campaigns_array.length === 0">
          <tr></tr>
          <tr>
            <td class="text-center" colspan="3">
              <!-- <div class="h6 my-3 text-center">{{ $t('NoRecords') }}</div> -->
              <NoRecords/>
            </td>
          </tr>
        </tbody>
      </table>
    </div>

    <!-- <b-pagination
      v-model="currentPage"
      total-rows="rows"
      @change="onChangePagination($event)"
      :per-page="perPage"
      aria-controls="my-table"
    ></b-pagination>-->
  </div>
</template>
<script>
import MarketingAutomation from "@/services/MarketingAutomationService";
import moment from "moment";
import NoRecords from "@/components/Partials/NoRecords.vue";

export default {
  components:{
    NoRecords
  },
  data() {
    return {
      campaigns_array: []
    };
  },
  mounted() {
    this.getSmsCampaigns();
  },
  methods: {
    getSmsCampaigns() {
      MarketingAutomation.getSmsCampaigns()
        .then(response => {
          const { data } = response;
          if (data && data.status) {
            this.campaigns_array = data.Records;
            console.log("this.campaigns_array :", this.campaigns_array);
          } else {
            this.$toasted.show(data.message);
          }
        })
        .catch(error => {
          this.$toasted.show(error);
        });
    }
  }
};
</script>


// WEBPACK FOOTER //
// src/components/Pages/MarketingAutomationContainer/SmsComponents/smsCampaign.vue